import { useEffect, useState } from "react";
import constants from "../../Utils/constants";
import bagImg from "../../assets/img/employeSVG.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";

const DetailsEmploymentInfo = (props) => {
  const { user = null, forensicAnalysis = {}, handleInfoModal } = props;
  const { _t } = useTranslator();

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }
  };

  const employementType = haveValue(
    forensicAnalysis?.["Employment Type"]?.dataInJSON?.employmentType
  )
    ? forensicAnalysis?.["Employment Type"]?.dataInJSON?.employmentType
    : user?.employment_status;

  return (
    <>
      <div className="main_doc_div mt-3">
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={bagImg} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("employmentInformation")}</p>
        </div>
        <div className="row">
          <div className="col-4">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(forensicAnalysis?.["Employment Type"])
                  ? "cursor-pointer custom-tooltip"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (haveValue(forensicAnalysis?.["Employment Type"])) {
                  handleInfoModal(forensicAnalysis?.["Employment Type"]);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("employmentStatus")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.["Employment Type"]?.verifiedSource ==
                  true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(
                  forensicAnalysis?.["Employment Type"]?.dataInJSON
                    ?.employmentType
                )
                  ? _t(
                      forensicAnalysis?.["Employment Type"]?.dataInJSON
                        ?.employmentType
                    )
                  : getEmploymentStatus()}
              </p>
            </div>
          </div>
          {(employementType ?? "").toLowerCase() !== constants.student ? (
            <div
              className={`col-4 ${
                haveValue(forensicAnalysis?.Employer)
                  ? "cursor-pointer custom-tooltip"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (haveValue(forensicAnalysis?.Employer)) {
                  handleInfoModal(forensicAnalysis?.["Employer"]);
                }
              }}
            >
              <div className="Indo_form BorderB2 ">
                <div className=" d-flex align-items-center gap-1">
                  <p className="formlabel d-block">{_t("employerName")}</p>
                  {forensicAnalysis?.["Employer"]?.verifiedSource == true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <p className="placeholderTest">
                  {Array.isArray(
                    forensicAnalysis?.["Employer"]?.dataInJSON?.employers
                  ) &&
                  forensicAnalysis?.["Employer"]?.dataInJSON?.employers.length >
                    0
                    ? `${
                        forensicAnalysis?.["Employer"]?.dataInJSON?.employers[0]
                          ?.employerName
                      } ${
                        forensicAnalysis?.["Employer"]?.dataInJSON?.employers
                          .length > 1
                          ? _t("andMore")
                          : ""
                      }`
                    : haveValue(user?.name_of_company)
                    ? user?.name_of_company
                    : "N/A"}
                </p>
              </div>
            </div>
          ) : (
            <>
              <div className="col-4">
                <div className="Indo_form BorderB2 ">
                  <p className="formlabel d-block">{_t("highestEducation")}</p>
                  <p className="placeholderTest">
                    {_t(user?.type_of_student, "", "fixed")}
                  </p>
                </div>
              </div>
              <div className="col-4">
                <div className="Indo_form BorderB2 ">
                  <p className="formlabel d-block">{_t("institution")}</p>
                  <p className="placeholderTest">{user?.name_of_university}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DetailsEmploymentInfo;
